const cmsActions = {
  CREATE_CMS: 'CREATE_CMS',
  CREATE_CMS_ENDED: 'CREATE_CMS_ENDED',
  SEARCH_CMS: 'SEARCH_CMS',
  SEARCH_CMS_ENDED: 'SEARCH_CMS_ENDED',
  FIND_CMS: 'FIND_CMS',
  FIND_CMS_ENDED: 'FIND_CMS_ENDED',
  UPDATE_CMS: 'UPDATE_CMS',
  UPDATE_CMS_ENDED: 'UPDATE_CMS_ENDED',
  DELETE_CMS: 'DELETE_CMS',
  DELETE_CMS_ENDED: 'DELETE_CMS_ENDED',
  CREATE_CMS_CATEGORY: 'CREATE_CMS_CATEGORY',
  CREATE_CMS_CATEGORY_END: 'CREATE_CMS_CATEGORY_END',
  SEARCH_CMS_CATEGORY: 'SEARCH_CMS_CATEGORY',
  SEARCH_CMS_CATEGORY_END: 'SEARCH_CMS_CATEGORY_END',
  FIND_CMS_CATEGORY: 'FIND_CMS_CATEGORY',
  FIND_CMS_CATEGORY_END: 'FIND_CMS_CATEGORY_END',
  UPDATE_CMS_CATEGORY: 'UPDATE_CMS_CATEGORY',
  UPDATE_CMS_CATEGORY_END: 'UPDATE_CMS_CATEGORY_END',
  DELETE_CMS_CATEGORY: 'DELETE_CMS_CATEGORY',
  DELETE_CMS_CATEGORY_END: 'DELETE_CMS_CATEGORY_END',
  UPDATE_ALL_CMS: 'UPDATE_ALL_CMS',
  UPDATE_ALL_CMS_ENDED: 'UPDATE_ALL_CMS_ENDED',
  ARCHIVE_ALL_CMS: 'ARCHIVE_ALL_CMS',
  ARCHIVE_ALL_CMS_ENDED: 'ARCHIVE_ALL_CMS_ENDED',
  BATCH_UPDATE_CMS_WEIGHT: 'BATCH_UPDATE_CMS_WEIGHT',
  BATCH_UPDATE_CMS_WEIGHT_END: 'BATCH_UPDATE_CMS_WEIGHT_END',
};

export default cmsActions;
